<script lang="ts">
	import { createBubbler } from 'svelte/legacy';

	import { cn } from '@ui-lib/utils/utils';
	import type { HTMLAttributes } from 'svelte/elements';

	const bubble = createBubbler();

	type $$Props = HTMLAttributes<HTMLDivElement>;

	interface Props {
		class?: $$Props['class'];
		children?: import('svelte').Snippet;
		[key: string]: any;
	}

	let { class: className = undefined, children, ...rest }: Props = $props();
</script>

<div
	class={cn(
		'border-2px-white/50 w-full max-w-md rounded-2xl bg-transparent shadow-lg shadow-[rgb(75,115,200)]/25 focus:outline-none focus:ring-2 focus:ring-[rgb(75,115,200)]/50 focus:ring-offset-2 focus:ring-offset-transparent ',
		className
	)}
	onclick={bubble('click')}
	{...rest}
>
	{@render children?.()}
</div>
